import { Auth } from "aws-amplify";
import { SignIn } from "aws-amplify-react";

import { rememberReturnTo } from "../auth/authRecovery";

class _CustomSignIn extends SignIn {
  constructor(props) {
    super(props);
    this._validAuthStates = ["signIn", "signedOut", "signedUp"];
    this.signIn = this.signIn.bind(this);
  }

  componentDidMount() {
    Auth.currentAuthenticatedUser().catch(() => {
      // A deep link opened without a session comes back to that page, not the
      // dashboard (App.tsx takes it after sign-in).
      rememberReturnTo();
      Auth.federatedSignIn();
    });
  }
}

const CustomSignIn = _CustomSignIn as unknown as React.FC<React.PropsWithChildren<unknown>>;

export default CustomSignIn;
